export default "__VITE_ASSET__RaRDFhqc__"